import React from "react";

export default function TextInput(props) {
  return (
    <div className="input__outer">
      {props.label && (
        <label htmlFor={props.label.replace(/\s/g, "")} className="mb-1">
          {props.label}{" "}
          {props.isRequired ? <span className="!text-red-500"> *</span> : ""}
        </label>
      )}
      <div
        className={
          "input " +
          (props.icon ? " wIcon" : "")
        }
      >
        {" "}
        {props.autoComplete ? (
          <input
            className={`${props.className} `}
            ref={props.inpRef}
            onChange={props.onChange}
            value={props.value}
            type={props.type}
            placeholder={props.placeholder}
            onKeyDown={props.onKeydown}
            onFocus={props.onFocus}
            readOnly={props.readOnly}
            name={props.label ? props.label.replace(/\s/g, "") : ""}
            id={props.label ? props.label.replace(/\s/g, "") : ""}
            autoComplete={props.autocomplete}
            autoFocus={props.autoFocus ? props.autoFocus : ""}
          />
        ) : (
          <input
            className={`${props.className} `}
            ref={props.inpRef}
            onChange={props.onChange}
            value={props.value}
            type={props.type}
            placeholder={props.placeholder}
            onKeyDown={props.onKeydown}
            onFocus={props.onFocus}
            readOnly={props.readOnly}
            name={props.label ? props.label.replace(/\s/g, "") : ""}
            id={props.label ? props.label.replace(/\s/g, "") : ""}
            autoFocus={props.autoFocus ? props.autoFocus : ""}
          />
        )}
        {props.icon && (
          <div
            className={"input__icon"}
            onClick={() => props.btnClickHandler(props.inpRef.current)}
          >
            {props.icon}
          </div>
        )}
      </div>
      {props.showList && !props.readOnly && (
        <div
          className={
            "input__options" + (props.list?.length === 0 ? " nospace" : "")
          }
        >
          {props.autoCompleteList.map((item, index) => (
            <div
              className="input__option "
              key={index}
              onClick={() => props.optionClickHandler(item)}
            >
              {item}
            </div>
          ))}
        </div>
      )}
      {((props.error && props.value === "") ||
        (props.errorZero && props.value <= 0)) && (
        <div className="input__error !mt-5 !text-sm !text-red-600">{props.errorText}</div>
      )}

      {props.error && props.list && props.showList !== true && props.list?.length === 0 && (
          <div className="input__error ">{props.errorText}</div>
        )}
    </div>
  );
}
